import { SuccessPlaceholder } from '@components'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { Button } from '@heroui/react'
import PropTypes from 'prop-types'

const PasswordResetSuccessPlaceholder = ({ 
  children,
  handleCopyToClipboard, 
  message, 
  password, 
  title
}) => (
  <SuccessPlaceholder 
    title={title}
    message={message}
  >
    <div className='flex flex-col justify-center py-4 mt-8 rounded-lg bg-content2 w-100'>
      <h2 className="text-xl font-semibold">Account Password</h2>
      <p>A random password has been generated for this account. The parent can change this after login by going to the account section.</p>
      <p className='mt-4 mb-1 font-semibold text-center text-red-600'>Note this down as it will not be shown again.</p>

      <div className="flex items-center justify-center gap-3 mb-2">
        <p className='text-5xl font-bold'>{password}</p>

        <Button onPress={() => handleCopyToClipboard(password)} isIconOnly>
          <DocumentDuplicateIcon className="p-1 text-white bg-gray-400 h-14 w-14" />
        </Button>
      </div>
    </div>

    {children}
  </SuccessPlaceholder>
)

PasswordResetSuccessPlaceholder.propTypes = {
  children: PropTypes.node,
  handleCopyToClipboard: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export { PasswordResetSuccessPlaceholder }